import { Pipe, PipeTransform } from '@angular/core';
import { DashboardItemAgendaComponent } from './dashboard-item/dashboard-item-agenda/dashboard-item-agenda.component';
import { DashboardItemGraphiqueComponent } from './dashboard-item/dashboard-item-graphique/dashboard-item-graphique.component';
import { DashboardItemGridComponent } from './dashboard-item/dashboard-item-grid/dashboard-item-grid.component';
import { DashboardItemMessageComponent } from './dashboard-item/dashboard-item-message/dashboard-item-message.component';
import { DashboardItemElearningComponent } from './dashboard-item/dashboard-item-elearning/dashboard-item-elearning.component';

@Pipe({
  name: 'casttocomponent'
})

export class CastToComponentPipe implements PipeTransform {
  transform(value: string): any {
    // JC : Peut-être utiliser un switch
    if (value === 'DashboardItemAgendaComponent') {
      return DashboardItemAgendaComponent;
    } else if (value === 'DashboardItemGraphiqueComponent') {
      return DashboardItemGraphiqueComponent;
    } else if (value === 'DashboardItemGridComponent') {
      return DashboardItemGridComponent;
    } else if (value === 'DashboardItemMessageComponent') {
      return DashboardItemMessageComponent;
    } else if (value === 'DashboardItemElearningComponent') {
      return DashboardItemElearningComponent;
    }
  }
}

